import type {
  IOutsourcedOrdersQueryParams,
} from '../../../hooks/outsourcingOrders/interfaces';

export type OutsourcingReportExportParams = Pick<
  IOutsourcedOrdersQueryParams,
  | 'statuses'
  | 'sequence'
  | 'partnerId'
  | 'dateFrom'
  | 'dateTo'
  | 'dateField'
  | 'sortBy'
  | 'sortDirection'
> & {
  timezone?: string;
};

export function buildOutsourcingReportExportParams(
  query: IOutsourcedOrdersQueryParams,
  timezone?: string
): OutsourcingReportExportParams {
  return {
    statuses: query.statuses,
    sequence: query.sequence,
    partnerId: query.partnerId,
    dateFrom: query.dateFrom,
    dateTo: query.dateTo,
    dateField: query.dateField,
    sortBy: query.sortBy,
    sortDirection: query.sortDirection,
    timezone,
  };
}
